import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3a4cfcaf")
const _hoisted_1 = { class: "personal-cloud-space" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "云空间", -1)
const _hoisted_3 = { class: "progress-bar" }
const _hoisted_4 = { class: "popover-cloud-space-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "课件", -1)
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "popover-cloud-space-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "音乐律动", -1)
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "progress-text" }
_popScopeId()

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_popover = _resolveComponent("a-popover")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["progress-fill", [
          _ctx.progressPercent > 70
            ? _ctx.progressPercent < 100
              ? 'percent-middle'
              : 'percent-full'
            : 'percent-low'
        ]]),
        style: _normalizeStyle({ width:_ctx.progressPercent  + '%' })
      }, null, 6),
      _createVNode(_component_a_popover, {
        title: "云空间使用情况",
        overlayClassName: "popover-cloud-space"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.cloudSpace.coursewareSize), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.cloudSpace.melodySize), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.cloudSpace?.totalSize) + "/" + _toDisplayString(_ctx.cloudSpace?.spaceLimit), 1)
        ]),
        _: 1
      })
    ])
  ]))
}